import styled from '@emotion/styled'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
`

export const AlertContent = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  gap: 16px;
  padding-left: 16px;
`
